import { createAction } from 'redux-actions';
import { REPLY_RECOMMENDATION_RECEIVED } from '../constants/actionTypes';
export const replyRecommendationReceived = createAction(REPLY_RECOMMENDATION_RECEIVED, ({
  message,
  threadId
}) => ({
  message,
  threadId
}));